import Vue from "vue";
import App from "./App.vue"; //引入跟组件
import router from "./router";
import "./plugins/element.js";
import * as echarts from 'echarts'
import { downloadFile } from '@/utils/fileRequest';
import { apiUrl } from '@/utils/request';
Vue.prototype.$echarts = echarts
import JsonBigInt from '@/components/common/JsonBigInt';
import UDialog from '@/components/common/u-dialog'
Vue.use(JsonBigInt);
 Vue.component('u-dialog', UDialog);
import "./assets/css/global.css";
import "./assets/css/common.css";
import "./assets/css/style.min.css";
import "./assets/css/hd.css";
import "./assets/fonts/iconfont.css";


// 语言包
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n=new VueI18n({
    locale:localStorage.getItem('language')||'cn',   //从localStorage里获取用户中英文选择，没有则默认中文
    messages:{
        'cn':require('./components/language/cn'),
        'en':require('./components/language/en')
    }
})
console.log(VueI18n,'VueI18n')



// import VueResource from 'vue-resource'
// Vue.use(VueResource)
// 导入全局样式
//导入字体图标
import Router from 'vue-router'
import store from './store'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
import axios from './utils/request';
//将引入的axios挂载到vue的原型对象上，全局配置axios，
Vue.prototype.$http = axios;

Vue.config.productionTip = false;


router.beforeEach((to, from, next) => {
    if(to.path === '/receiveShare' && to.query.id && to.query.verification) {
        //downloadFile('post', `/share/download/${to.query.id}/${to.query.verification}`,)
        // 先发送HEAD请求检查文件是否存在
        const checkUrl = `${apiUrl}/share/download/${to.query.id}/${to.query.verification}`;
        // const response = await fetch(checkUrl, { method: 'HEAD' });    
        // if (!response.ok) {
        //     // 文件不存在或请求失败时提示
        //     ElMessage.error('文件不存在');
        //     return;
        // }    
        // 文件存在时执行下载
        const link = document.createElement('a');
        link.href = checkUrl;
        // 可选：设置下载文件名（如果后端支持）
        // link.download = 'filename.ext';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return 
    }
    if(!localStorage.token) {
        if(to.path == '/login') {
            return next()
        }
        next('/login?cbUrl=' + encodeURIComponent(location.pathname + location.search))
    }
    else {
        if(to.path == '/login') {
            return next();
        }
        let userMenus = store.state.userMenus;
        if(!userMenus.length) {
            store.dispatch('GET_USER_MENU').then(() => {
                checkCanToNext(to, next)
            })
        }
        else {
            checkCanToNext(to, next)
        }
    }
})

function checkCanToNext(to, next) {
    const userMenus = store.state.userMenus;
    next()
    return 
    if(userMenus.includes(to.path)) {
        next()
    }
    else {
        next('/noPermission')
    }
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
